import Button from "./Button/Button";

const SidebarFooter = ({ cancelText, saveText, handleClose, handleSave, isDisabledNext, isDisabledPrev, loading }: any) => {
  return (
    <div className="fixed bottom-0 right-0 w-11/12 max-w-120 z-30 bg-docsigna-pink-light border-t">
      <div className="px-8 py-5 flex justify-end">
        <Button
          disabled={isDisabledPrev || loading}
          onClick={handleClose}
          className="pointer px-5 mr-3"
          text={cancelText}
          width="fit"
          variant="Secondary"
        />
        <div>
          <Button
            disabled={isDisabledNext || loading}
            onClick={handleSave}
            className="pointer px-5"
            text={saveText}
            width="fit"
            variant={loading ? "loading" : "Primary"}
          />
        </div>
      </div>
    </div>
  );
};

export default SidebarFooter;
